import React from 'react';
import { List, Props as ListProps } from './list';
import { ListItem, Props as ListItemProps, ListOption } from './list-item';
import { StyleProp, View, ViewStyle } from 'react-native';

interface Props<TListOption> {
  data: TListOption[];
  listProps?: Partial<ListProps<TListOption>>;
  scrollEnabled?: boolean;
  sharedProps: Partial<ListItemProps<TListOption>>;
  style?: StyleProp<ViewStyle>;
}

export const MaybeScrollingList = <TListOption extends ListOption>({
  data,
  listProps,
  scrollEnabled,
  sharedProps,
  style,
}: Props<TListOption>) => {
  if (scrollEnabled) {
    return (
      <List<TListOption>
        contentContainerStyle={style}
        data={data}
        ItemSeparatorComponent={null}
        {...listProps}
        {...sharedProps}
      />
    );
  }

  return (
    <View style={style}>
      {data.map((option, index) => (
        <ListItem<TListOption>
          key={`maybe-scrolling-${index}`}
          {...sharedProps}
          item={option}
        />
      ))}
    </View>
  );
};
